import { useContext } from 'react';
import { DownloadFailedDocumentsJobContext } from './context';

export default function useDownloadFailedDocumentsJobContext() {
  return useContext(DownloadFailedDocumentsJobContext);
}
